<template>
    <div id="personal_monitor">
        <Operations></Operations>
        <div class="ui divider"></div>
        <CoreWaybillsUnderOperations></CoreWaybillsUnderOperations>
        <div class="ui divider"></div>
        <CoreWaybillsUnderScans></CoreWaybillsUnderScans>
    </div>
</template>

<script>
import Operations from "../.components/personal/operations/index.vue"
import CoreWaybillsUnderOperations from "../.components/personal/core_waybills_under_operations/index.vue"
import CoreWaybillsUnderScans from "../.components/personal/core_waybills_under_scans/index.vue"

export default {
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    components: {
        Operations,
        CoreWaybillsUnderOperations,
        CoreWaybillsUnderScans,
    }
}
</script>
<style scoped>
</style>
